<div *ngIf="reportType === 'InDetailALL'">
  <div class="report-container" id="print-section" 
       style="font-family: Arial, sans-serif; border: 1px solid black;margin-left:10mm">

    <!-- ===== HEADER SECTION ===== -->
    <table style="width: 100%; border-collapse: collapse; border-bottom: 1px solid black; background-color: #f8f9fa;">
      <tr>
        <td style="font-size: 18px; font-weight: bold; text-align: center; white-space: nowrap; padding: 8px;">
          हिंदुस्तान प्रकाशन संस्था  
        </td>
        <td style="font-size: 20px; font-weight: bold; text-align: center;">
          Book Payment Receipt Report
        </td>
        <td style="font-size: 18px; text-align: right; white-space: nowrap; padding: 8px;">
          दिनांक {{ currentDate | date: 'dd-MM-yyyy' }}
        </td>
      </tr>

      <tr style="border-top: 1px solid black;">
        <td style="padding: 8px;font-weight: bold;font-size: 18px;text-align: center;">विवेक पुस्तक प्रकाशन</td>
        <td style="font-size: 18px; font-weight: bold; text-align: center; padding: 8px;">
          In Detail
        </td>
        <td style="font-size: 16px; text-align: right; white-space: nowrap; padding: 8px;font-weight: bold;">
          Date : From {{ startDate | date:'dd-MM-yyyy' }} To {{ endDate | date:'dd-MM-yyyy' }}
        </td>
      </tr>
    </table>

    <!-- ===== MAIN TABLE ===== -->
    <div class="table-responsive" style="margin: 0;">
      <table style="width: 100%; border-collapse: collapse; border: 1px solid black; border-top: none;">
        <thead>
          <tr style="background-color: #f1f1f1; text-align: center;">
            <th style="border: 1px solid black; padding: 6px 10px;font-size: 16px;">Receipt Date</th>
            <th style="border: 1px solid black; padding: 6px 10px;font-size: 16px;">Receipt No</th>
            <th style="border: 1px solid black; padding: 6px 10px;font-size: 16px;">Entry Date</th>
            <th style="border: 1px solid black; padding: 6px 10px;font-size: 16px;">Voucher No</th>
            <th style="border: 1px solid black; padding: 6px 12px;font-size: 16px;">Book Seller Name</th>
            <th style="border: 1px solid black; padding: 6px 10px;font-size: 16px;">Order No</th>
            <th style="border: 1px solid black; padding: 6px 10px;font-size: 16px;">Order Date</th>
            <th style="border: 1px solid black; padding: 6px 10px;font-size: 16px;">Invoice No</th>
            <th style="border: 1px solid black; padding: 6px 10px;font-size: 16px;">Invoice Date</th>
            <th style="border: 1px solid black; padding: 6px 10px;font-size: 16px;">Invoice<br>Amount</th>
            <th style="border: 1px solid black; padding: 6px 10px;font-size: 16px;">Received<br>Amount</th>
          </tr>
        </thead>

        <tbody>
          <ng-container *ngFor="let office of PaymentBookOffInDFormBenas">
            
            <!-- Office Representative Header -->
            <tr >
              <td colspan="11" 
    style="text-align: center; 
           font-weight: bold; 
           border: 1px solid black; 
           padding: 6px; 
           font-size: 17px;">
  Office Representative: {{ office.office_rep_name }}
</td>

            </tr>

            <!-- Representative Loop -->
            <ng-container *ngFor="let rep of office.rep_data">
              
              <!-- Rep Header -->
              <tr style="background-color: #f9f9f9;">
                <td colspan="11" style="font-weight: bold; border: 1px solid black; padding: 6px;">
                  Representative: {{ rep.rep_name }}
                </td>
              </tr>

              <!-- Seller Rows -->
              <tr *ngFor="let seller of rep.book_sellers" style="text-align: center;">
                <td style="white-space: nowrap; border: 1px solid black; padding: 6px 8px;">{{ seller.receipt_date }}</td>
                <td style="white-space: nowrap; border: 1px solid black; padding: 6px 8px;">{{ seller.receipt_no }}</td>
                <td style="white-space: nowrap; border: 1px solid black; padding: 6px 8px;">{{ seller.entry_date }}</td>
                <td style="white-space: nowrap; border: 1px solid black; padding: 6px 8px;">{{ seller.voucher_no }}</td>
                <td style="white-space: nowrap; border: 1px solid black; text-align: left; padding: 6px 10px;">{{ seller.book_seller_name }}</td>
                <td style="white-space: nowrap; border: 1px solid black; padding: 6px 8px;">{{ seller.order_no }}</td>
                <td style="white-space: nowrap; border: 1px solid black; padding: 6px 8px;">{{ seller.order_date }}</td>
                <td style="white-space: nowrap; border: 1px solid black; padding: 6px 8px;">{{ seller.book_invoice_no }}</td>
                <td style="white-space: nowrap; border: 1px solid black; padding: 6px 8px;">{{ seller.billdate }}</td>
                <!-- <td style="white-space: nowrap; border: 1px solid black; padding: 6px 8px;">{{ seller.issue_invoice_date }}</td> -->
                <td style="text-align: right; border: 1px solid black; padding: 6px 8px;">{{ seller.net_amt  }}</td>
                <td style="text-align: right; border: 1px solid black; padding: 6px 8px;">{{ seller.rcv_amt  }}</td>
              </tr>

              <!-- Rep Total -->
              <tr >
                <td colspan="10" style="text-align: right; font-weight: bold; border: 1px solid black; padding: 6px 10px;">
                  Rep Total: {{ rep.rep_name }}
                </td>
                <td style="text-align: right; font-weight: bold; border: 1px solid black; padding: 6px 8px;">
                  {{ rep.rep_total_rcv  }}
                </td>
              </tr>
            </ng-container>

            <!-- Office Total -->
            <tr style=" background-color: #f4b084;">
              <td colspan="10" style="text-align: right; font-weight: bold; border: 1px solid black; padding: 6px 10px;">
                Office Rep Total: {{ office.office_rep_name }}
              </td>
              <td style="text-align: right; font-weight: bold; border: 1px solid black; padding: 6px 8px;">
                {{ office.total_rcv_amt  }}
              </td>
            </tr>
          </ng-container>
        </tbody>

        <!-- Grand Total -->
        <tfoot>
          <tr style="background-color: #c8753f; font-weight: bold;">
            <td colspan="10" style="text-align: right; border: 1px solid black; padding: 6px 10px;">
              Grand Total:
            </td>
            <td style="text-align: right; border: 1px solid black; padding: 6px 8px;">
              {{ PaymentbookOffInDTotal2 }}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>

  <!-- ===== ACTION BUTTONS ===== -->
  <div class="button-container noPrint" style="margin-top: 20px; text-align: center;">
    <button mat-raised-button color="primary" (click)="exportExcel('Book_InDetail_Officewise')">📊 Export</button>
    <button mat-raised-button color="accent" (click)="printPage4()">🖨️ Print</button>
    <button mat-button mat-dialog-close>❌ Close</button>
  </div>
</div>
